import { atomWithStorage } from "jotai/utils";

export const insightsConfigAtom = atomWithStorage<{
    generalCounts: boolean;
    emissionList: boolean;
    infraInsights: boolean;
    thirdPartyInsights: boolean;
    bridgerInsights: boolean;
    nonDetects: boolean;
}>("insightsConfig", {
    generalCounts: true,
    emissionList: true,
    infraInsights: true,
    thirdPartyInsights: true,
    bridgerInsights: true,
    nonDetects: true,
});
